module.exports = __webpack_public_path__ + "static/media/background.c6d8a810.png";